<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >
      <div class="form_title">选择发送范围</div>
      <a-row :gutter="24">
        <div class="ant-row ant-form-item">
          <div class="ant-col ant-col-4 ant-form-item-label">
            <label class="ant-form-item-required">选择员工</label>
          </div>
          <div class="ant-col ant-col-20 ant-form-item-control-wrapper">
            <userPickerWithNoParents ref="userPickerWithNoParents"></userPickerWithNoParents>
          </div>
        </div>
      </a-row>
      <div class="form_title">基本信息</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="发送标题"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['taskTitle']"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="发送内容"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-textarea v-decorator="['taskContent',rules.taskContent]"/>
          </a-form-item>
        </a-col>
      </a-row>

      <div class="form_title">添加照片/视频/文件/网页/小程序</div>
      <a-row :gutter="24">
        <a-col>
          <a-form-item label="消息类型"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-radio-group button-style="solid" v-model="msgType">
              <a-radio-button value="image">图片</a-radio-button>
              <a-radio-button value="video">视频</a-radio-button>
              <a-radio-button value="file">文件</a-radio-button>
              <a-radio-button value="link">图文链接</a-radio-button>
              <a-radio-button value="miniprogram">小程序</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>

      <div style="color: #ff0000;line-height: 30px">（仅可选择一类消息类型，若切换则已填写内容会被清空）</div>
      <a-row :gutter="24">
        <template v-if="msgType === 'image'">
          <a-form-item label="图片设置"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="9" v-decorator="['imageUrls']" :accept="'image/*'"
                      :url="api.temp.WX_UPLOAD_PATH+'?uploadType=2'"></uploader>
          </a-form-item>
          <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：png,jpg,gif，建议大小2M，最多9张</span>
        </template>
        <template v-if="msgType === 'video'">
          <a-form-item label="视频设置"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['videoUrls']" :accept="'video/*'"
                      :url="api.temp.WX_UPLOAD_PATH+'?uploadType=2'"></uploader>
          </a-form-item>
          <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：mp4，建议大小2M，最多1个</span>
        </template>
        <template v-if="msgType === 'file'">
          <a-form-item label="文件设置"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['fileUrls']" :accept="'*'"
                      :url="api.temp.WX_UPLOAD_PATH+'?uploadType=2'"></uploader>
          </a-form-item>
          <span style="color: #f00;margin-left: 16.66666666666666666%">建议大小2M，最多1个</span>
        </template>
        <template v-if="msgType === 'miniprogram'">
          <a-form-item label="小程序标题"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['miniprogramTitle',rules.miniprogramTitle]"/>
          </a-form-item>
          <a-form-item label="小程序appid"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['miniprogramAppid',rules.miniprogramAppid]"/>
          </a-form-item>
          <a-form-item label="小程序页面地址"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['miniprogramPage',rules.miniprogramPage]"/>
          </a-form-item>
          <a-form-item label="小程序封面图"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['miniprogramImgUrl']" :accept="'image/*'"
                      :url="api.temp.WX_UPLOAD_PATH+'?uploadType=2'"></uploader>
          </a-form-item>
          <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：png,jpg，封面图建议尺寸为520*416</span>
        </template>
        <template v-if="msgType === 'link'">
          <a-form-item label="网页标题"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['linkTitle',rules.linkTitle]"/>
          </a-form-item>
          <a-form-item label="网页链接"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <a-input v-decorator="['linkUrl',rules.linkUrl]"/>
          </a-form-item>
          <a-form-item label="网页封面图"
                       :label-col="{ span: 4 }"
                       :wrapper-col="{ span: 20 }">
            <uploader :num="1" v-decorator="['linkImgUrl']" :accept="'image/*'"
                      :url="api.temp.WX_UPLOAD_IMG_PATH"
            ></uploader>
          </a-form-item>
          <span style="color: #f00;margin-left: 16.66666666666666666%">建议格式：png,jpg，建议大小2M</span>
        </template>
      </a-row>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="close()">取消</a-button>
      <a-button v-if="keyId<=0" type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin, fmt} from '@/utils/common/FormBase'
//厂商用户管理接口
import {dataApi} from '@/services/operate/MassSendCustomer';
import userPickerWithNoParents from '@/components/picker/userPickerWithNoParents.vue';

/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    linkTitle: {
      rules: [{required: true, message: "请输入网页标题"}]
    },
    linkUrl: {
      rules: [{required: true, message: "请输入网页链接"}]
    },
    miniprogramTitle: {
      rules: [{required: true, message: "请输入小程序标题"}]
    },
    miniprogramAppid: {
      rules: [{required: true, message: "请输入小程序appid"}]
    },
    miniprogramPage: {
      rules: [{required: true, message: "请输入小程序页面地址"}]
    },
    miniprogramImgUrl: {
      rules: [{required: true, message: "请上传小程序封面图"}]
    },
    sender: {
      rules: [{required: true, message: "请选择通知成员"}]
    },
    taskContent: {
      rules: [{required: true, message: "请输入发送内容"}]
    }
  };
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {};
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  if (entity.data.userType === 1) {
    this.$refs.userPickerWithNoParents.setData(entity.data.userType, entity.data.sender, entity.data.senderName)
  } else {
    this.$refs.userPickerWithNoParents.setData(entity.data.userType, entity.data.deptIds, entity.data.deptName)
  }
  if (entity.data.msgtype === 'image') {
    entity.data.imageUrls = entity.data.attachmentUrls;
  } else if (entity.data.msgtype === 'video') {
    entity.data.videoUrls = entity.data.attachmentUrls;
  }
  return fmt.formatFormLoad(entity);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.msgtype = vm.msgType;
  if (entities.msgtype === 'image') {
    entities.attachmentUrls = entities.imageUrls;
  } else if (entities.msgtype === 'video') {
    entities.attachmentUrls = entities.videoUrls;
  }
  if (!entities.attachmentUrls) {
    entities.msgtype = ''
  }
  //给主键赋值
  entities.taskId = vm.keyId;
  entities.taskType = 1;
  const params = this.$refs.userPickerWithNoParents.getSelectData()
  console.log(params)
  if (params.userIds.length === 0 && params.deptIds.length === 0) {
    throw '请选择员工'
  }
  if (params.type === 'customer') {
    entities.userType = 1
    entities.sender = params.userIds
  } else {
    entities.userType = 2
    entities.deptIds = params.deptIds
  }
  return await dataApi.saveFormDetail(entities);
}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    userPickerWithNoParents
  },
  data() {
    return {
      msgType: 'image',
      customerData: [],
      senderName: '',
      ids: '',
    }
  },
  mounted() {

  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData
  }
};
</script>